import { SurveyNavigationErrorAction } from './survey-navigation-error-action.type';

export const SURVEY_NAVIGATION_ERROR_MESSAGES: Record<SurveyNavigationErrorAction, { title: string; message: string }> = {
  next: {
    title: 'We couldn\u0027t save your answer',
    message: 'Please try Next again. If the problem continues, refresh the page.'
  },
  back: {
    title: 'We couldn\u0027t go back',
    message: 'Please try Previous again. If the problem continues, refresh the page.'
  },
  complete: {
    title: 'We couldn\u0027t submit your survey',
    message: 'Please try Complete again. If the problem continues, refresh the page.'
  }
};
